import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Home, AlertTriangle } from 'react-feather';
import { Button } from '../components/ui/button';

const NotFound: React.FC = () => {
  const navigate = useNavigate();
  const navigateHome = () => {
    navigate('/');
  };
  return (
    <div className="d-flex align-items-center justify-content-center vh-100">
      <div className="w-100">
        <div className="text-center">
          <AlertTriangle size={64} className="text-warning mb-4" />
          <h1 className="display-4 mb-3">404</h1>
          <h2 className="mb-4">Page Not Found</h2>
          <p className="lead mb-4 text-muted">
            The page you are looking for might have been removed, had its name changed,
            or is temporarily unavailable.
          </p>
          <Button  className="btn-lg" onClick={navigateHome}>
            <Home size={18} className="me-2" />
            Return Home
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;